import { render, staticRenderFns } from "./SampleItems.vue?vue&type=template&id=058573d7"
import script from "./SampleItems.vue?vue&type=script&lang=js"
export * from "./SampleItems.vue?vue&type=script&lang=js"
import style0 from "./SampleItems.vue?vue&type=style&index=0&id=058573d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports